import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Select } from 'antd';
import HeaderBack from '../../../components/mobile/HeaderBack';
import MedicalHistoryModal from '../../../components/mobile/medical-history/MedicalHistoryModal';
import { ReactComponent as InfoCircleSvg } from '../../../assets/icons/medical-history/info-circle.svg';
import { ReactComponent as EditSvg } from '../../../assets/icons/medical-history/edit.svg';
import { ReactComponent as MedicalConditionSvg } from '../../../assets/icons/medical-history/medical-condition.svg';
import { ReactComponent as MedicationSvg } from '../../../assets/icons/medical-history/medication.svg';
import { ReactComponent as AllergiesSvg } from '../../../assets/icons/medical-history/allergies.svg';
import { ReactComponent as FamilyHistorySvg } from '../../../assets/icons/medical-history/family-history.svg';
// import { ReactComponent as SocialHistorySvg } from '../../../assets/icons/medical-history/social-history.svg';
import { ReactComponent as MeasurementsSvg } from '../../../assets/icons/medical-history/measurements.svg';

const { Title } = Typography;

const profiles = [
  {name: 'Emma Russell', value: 'Emma Russell'},
  {name: 'Emma Russell', value: 'Emma Russell'},
  {name: 'Emma Russell', value: 'Emma Russell'},
  {name: 'Emma Russell', value: 'Emma Russell'},
]

const styles = {
  info: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "center",
    color: "#15A9E1"
  },
  title: {
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#404047"
  },
  selectText: {
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#262626"
  },
  item: {
    border: "1px solid #EAEAEA",
    boxSizing: "border-box",
    padding: "25px",
    width: '100%'
  },
  itemTitle: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "26px",
    color: "#404047",
    margin: 0,
    marginLeft: 10
  },
  spanDanger: {
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "20px",
    padding: '1px 8px',
    boxSizing: "border-box",
    borderRadius: "2px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#FA8C16",
    background: "#FFF7E6",
    border: "1px solid #FFD591",
    marginRight: 10
  },
  spanSuccess: {
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "20px",
    padding: '1px 8px',
    boxSizing: "border-box",
    borderRadius: "2px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#52C41A",
    background: "#F6FFED",
    border: "1px solid #B7EB8F",
    marginRight: 10
  },
  emptyTag: {
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    color: "#15A9E1"
  },
  bmi: {
    fontWeight: "700",
    fontSize: "15px",
    lineHeight: "18px",
    textTransform: "capitalize",
    color: "#404047",
    marginBottom: 15
  }
}

const lists = [
  {
    icon: <MedicalConditionSvg />,
    title: 'Medical Conditions',
    url: '/medical-history/medical-condition',
    tag: [
      {
        title: 'Nil',
        isGood: false
      },
      {
        title: 'Type 2 Diabetes',
        isGood: false
      }
    ]
  },
  {
    icon: <MedicationSvg />,
    title: 'Medication',
    url: '/medical-history/medication',
    tag: [
      {
        title: 'Ibuprofen - 03/02/2022',
        isGood: false
      },
      {
        title: 'Nil',
        isGood: false
      }
    ]
  },
  {
    icon: <AllergiesSvg />,
    title: 'Allergies',
    url: '/medical-history/alergies',
    tag: [
      {
        title: 'Nil',
        isGood: false
      },
      {
        title: 'Nil',
        isGood: false
      }
    ]
  },
  {
    icon: <FamilyHistorySvg />,
    title: 'Family History',
    url: '/medical-history/family-history',
    tag: []
  },
  // {
  //   icon: <SocialHistorySvg />,
  //   title: 'Social History',
  //   url: '/medical-history/social-history',
  //   tag: [
  //     {
  //       title: 'Smoking: Never Smoked',
  //       isGood: true
  //     }
  //   ]
  // },
  {
    icon: <MeasurementsSvg />,
    title: 'Measurements',
    url: '/medical-history/measurements',
    tag: [
      {
        title: 'Height: 165cm',
        isGood: true
      },
      {
        title: 'Weight: 61kg',
        isGood: true
      }
    ]
  }
]

function MobileMedicalHistoryHomeScreen() {
  const { t } = useTranslation(['medical-history', 'common']);
  const history = useHistory();

  const [name, setName] = useState('');
  const [showInfo, setShowInfo] = useState(false)

  const onBack = () => {
    history.push('/homepage')
  }

  const onCancel = () => {
    setShowInfo(false)
  }

  const ItemList = ({icon, title, url, tag}) => {
    return (
      <Box style={styles.item}>
        <Row justify="center" align="middle" style={{marginBottom: 26}}>
          <Col xs={20}>
            <Row justify="start" align="middle">
              {icon}
              <Title level={4} style={styles.itemTitle}>
                {title}
              </Title>
            </Row>
          </Col>
          <Col xs={4}>
            <Button
              htmlType="button"
              type="primary"
              size="small"
              onClick={() => history.push(url)}
              ghost
              style={{alignItems: 'center', display: 'flex', justifyContent: 'row'}}
            >
              <EditSvg /> {t('common:button.edit')}
            </Button>
          </Col>
        </Row>
        {/* <Row justify="start" align="middle">
          {
            tag.length > 0 && tag.map(({title, isGood}) => <span style={isGood ? styles.spanSuccess : styles.spanDanger}>{title}</span>)
          }
          {
            tag.length === 0 && <span style={styles.emptyTag}>{t('medical-history:home.emptyTag')}</span>
          }
        </Row> */}
      </Box>
    )
  }

  return (
    <>
      <MedicalHistoryModal
        visible={showInfo}
        onCancel={onCancel}
      />
      <HeaderBack
        onBack={onBack}
        text={t('medical-history:home.backTitle')}
        title={t('medical-history:home.title')}
        subtitle={t('medical-history:home.subtitle')}
      />
      <Row justify="center" style={{ padding: 0, marginBottom: 35 }} onClick={() => setShowInfo(true)}>
        <Title level={4} style={styles.info}>
          {t('medical-history:home.howWork')}
        </Title>
        <InfoCircleSvg style={{ marginLeft: 5 }}/>
      </Row>
      <Box marginBottom={40}>
        <Row type="flex" align="middle" gutter={24} style={{ width: '100%' }}>
          <Col>
            <Title level={4} style={styles.selectText}>
              {t('medical-history:home.selectProfile')}
            </Title>
          </Col>
          <Col flex={1}>
            <div>
              <Select
                style={{ width: '90%' }}
                size="small"
                value={name}
                onChange={(value) => setName(value)}
              >
                {profiles.map(({ value, name }) => (
                  <Select.Option key={value} value={value}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
      </Box>
      <Row justify="center" style={{ padding: 0 }}>
        {lists.map(({icon, title, url, tag}) => <ItemList icon={icon} title={title} url={url} tag={tag} />)}
      </Row>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" marginTop="35px">
        <Title level={4} style={styles.bmi}>
          {t('medical-history:home.bmi')}
        </Title>
        <Button
          htmlType="button"
          type="primary"
          size="default"
          style={{alignItems: 'center', display: 'flex', justifyContent: 'row'}}
        >
          22.4 {t('medical-history:home.healthyWeight')}
        </Button>
        <Row justify="center" style={{ padding: 0, marginTop: 25, marginBottom: 33 }}>
          <Title level={4} style={styles.info}>
            {t('medical-history:home.calculation')}
          </Title>
          <InfoCircleSvg style={{ marginLeft: 5 }}/>
        </Row>
      </Box>
    </>
  );
}

export default MobileMedicalHistoryHomeScreen;
